

<div class="flex flex-col h-full" *ngIf="masterProducts?.length > 0 || options?.type === 'EDIT'">
  <div class="border-b border-b-gray-300 zuper-dialog-header" *ngIf="options?.modal?.footer?.isEnabled">
      <div class="flex justify-between">
          <h6 mat-dialog-title class="font-semibold primary-font">{{(options?.modal?.header?.headerDisplayKey ||
              options?.modal.header?.headerDisplayName || 'lineitem.picker.header.text') | translate}} {{(options?.type === 'EDIT' && this.selectedBundleDetails?.product_name) ? '\'' + this.selectedBundleDetails?.product_name + '\'': ''}}</h6>
      </div>
      <div class="flex items-center ml-auto" *ngIf="options?.modal.header.hideCloseIcon !== true">
          <span mat-dialog-close
              class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
              <em class="ti ti-x text-xl font-bold"></em>
          </span>
      </div>
  </div>
  <div class="rounded-md bg-gray-50 px-4 py-3 h-11">
    <div class="flex">
        <div class="flex-shrink-0">
            <i class="ti ti-alert-circle text-gray-700 text-2xl"></i>
        </div>
        <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-base text-gray-700">
            {{'bundle.picker.form.info' | translate}}  '{{displayBundlePricingLevel[selectedBundleDetails?.pricing_level] | translate}}'
          </p>
        </div>
    </div>
  </div>
  <a class="block w-full bg-white border-t border-b border-gray-200 p-4">
    <mat-expansion-panel [expanded]="isPrimaryDetailsExpanded" (opened)="isPrimaryDetailsExpanded = true" (closed)="isPrimaryDetailsExpanded = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="flex items-center justify-between w-full">
              <div>
                  <h5 class="my-3 text-lg font-semibold text-gray-700">
                      <i class="ti ti-box-padding text-2xl"></i>
                      <span class="ml-3">{{"text.primary_details" | translate}}</span>
                  </h5>
              </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="flex flex-col px-1 max-dialog-height overflow-y-auto zuper-scrollbar">
        <form [formGroup]="updateProductBundleForm" class="cancelForm h-full grid grid-cols-5 gap-6 pt-2 overflow-y-none" autocomplete="off">
          <ng-container *ngFor="let field of partsFormFields">
            <div *ngIf="field?.showField" 
                 [ngClass]="{
                   'col-span-5' : ['product_description','description','serial_nos'].includes(field?.fieldName), 
                   'col-span-1': !['product_description','description','serial_nos'].includes(field?.fieldName)
                 }">
              <div class="flex flex-col">
                <label class="primary-font mat-form-field font-semibold mb-2 text-base" [ngClass]="{'required': field?.isRequired}"
                  *ngIf="!['product_description','description'].includes(field?.fieldName) && field?.showField">
                  {{ field?.fieldLabel | translate }}
                </label>
        
                <div class="text-base break-words" 
                     *ngIf="field?.displayType === 'text' && !['product_description','description','location_uid','serial_nos','markup', 'price','unit_price','purchase_price','selling_price'].includes(field?.fieldName) && field?.showField">
                  {{ selectedBundleDetails[field?.fieldName] ?? '---' }}
                </div>
                <div class="text-base break-words"  *ngIf="field?.displayType === 'text' && ['price','unit_price','purchase_price','selling_price'].includes(field?.fieldName) && field?.showField">
                    {{(selectedBundleDetails[field?.fieldName] | currencyFormat) ??  '---'}}
                </div>
                <div class="text-base break-words" 
                     *ngIf="field?.displayType === 'text' && ['markup'].includes(field?.fieldName) && field?.showField">
                  {{ selectedBundleDetails[field?.fieldName]?.['markup_value'] ?? '---' }}
                </div>
        
                <div class="text-base break-words" 
                     *ngIf="field?.displayType === 'text' && ['location_uid'].includes(field?.fieldName) && field?.showField">
                  {{ locationName ?? '---' }}
                </div>
        
                <div class="flex flex-col w-full"  *ngIf="['product_description','description'].includes(field?.fieldName) && field?.showField">
                  <mat-label class="primary-font mat-form-field font-semibold mb-2 text-base" 
                             [ngClass]="{'required': field?.isRequired}"> {{ field?.fieldLabel | translate }}
                  </mat-label>
                  <div class="text-base break-words" *ngIf="field?.displayType === 'text'">
                    {{ utilityService.isEmptyOrUndefined(selectedBundleDetails[field?.fieldName]) ? '---' :  selectedBundleDetails[field?.fieldName] }}
                  </div>
                  <div class="mt-1 h-40" *ngIf="field?.displayType === 'input'">
                    <text-editor *ngIf="showEditor" [editorData]="updateProductBundleForm?.controls?.product_description" [options]="textEditorOptions"
                    (editorFocus)="initEditor($event)" style="font-size: 14px;"></text-editor>
                  </div>
                </div>
                <ng-container *ngIf="['price','unit_price','purchase_price','selling_price'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                  <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [floatLabel]="'always'" [hideRequiredMarker]="true" *ngIf="field?.displayType === 'input' && field?.showField">
                    <input type="number" [min]="!['price','selling_price'].includes(field?.fieldName) && 0" restrictNumberDecimal [step]="stepValue" [ngClass]="{'selling-price' :['price','selling_price'].includes(field?.fieldName)}" matInput class="form-control" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}">
                    <span matPrefix>{{companyCurrency}}</span>
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="['quantity'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                  <mat-form-field class="example-full-width w-full" appearance="fill" [floatLabel]="'always'" [hideRequiredMarker]="true">                    
                    <input numbersOnly type="number" step="1" min="1" matInput class="form-control" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}"
                    [ngClass]="{'border-red-600': updateProductBundleForm?.controls['quantity']?.invalid && updateProductBundleForm?.controls['quantity']?.touched}"
                    (paste)="$event.preventDefault()">
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="['discount'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                  <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [hideRequiredMarker]="true" [floatLabel]="'always'" *ngIf="field?.displayType === 'input' && field?.showField">
                    <input type="number" matInput class="form-control" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}">
                    <span matPrefix>
                      <mat-select formControlName="discount_type" (selectionChange)="onDiscountTypeChange($event)">
                        <mat-option [value]="option.value" *ngFor="let option of discountType"> {{option.key}} </mat-option>
                      </mat-select>
                    </span>
                  </mat-form-field>
                  <p *ngIf="updateProductBundleForm?.controls['discount_type'].value === 'PERCENTAGE' && (updateProductBundleForm?.controls['discount'].hasError('min') || updateProductBundleForm?.controls['discount'].hasError('max'))" class="text-base mt-1 text-red-500">
                    {{'discount.percentage.error' | translate}}
                  </p>
                  <p *ngIf="updateProductBundleForm?.controls['discount_type'].value === 'FIXED' &&  updateProductBundleForm?.controls['discount'].hasError('max')" class="text-base mt-1 text-red-500">
                    {{'text.enter_value_less' | translate}} {{getTotal() | currencyFormat}}
                  </p>
                </ng-container>
                <ng-container *ngIf="(field?.fieldName === 'tax_preference') && (field?.displayType === 'input') && field?.showField">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-select  [formControlName]="field.fieldName" (selectionChange)="onTaxPreferenceChange($event)">
                          <mat-option [value]="true"> {{ "text.non_taxable" | translate}} </mat-option>
                          <mat-option [value]="false"> {{ "taxable.text" | translate}} </mat-option>
                      </mat-select>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="(field?.fieldName === 'is_billable') && (field?.displayType === 'input') && field?.showField">
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-select  [formControlName]="field.fieldName">
                      <mat-option [value]="true"> {{ "yes" | translate}} </mat-option>
                      <mat-option [value]="false"> {{ "no" | translate}} </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="['tax_code'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                  <app-tax-code (codeSelected)="changeTaxCode($event)" [value]="selectedBundleDetails?.tax?.tax_code"></app-tax-code>
                </ng-container>
                <ng-container *ngIf="(field?.fieldName === 'markup') && (field?.displayType === 'input') && field?.showField">
                  <div class="flex">
                    <input type="number" [min]="0" [step]="stepValue" restrictNumberDecimal [formControlName]="field.fieldName"
                      (change)="markupValueChange($event)" placeholder="{{field?.placeholder | translate}}"
                      class="block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base">
                    <span [matMenuTriggerFor]="dropdown"
                      class="inline-flex items-center px-3 text-md text-gray-900 border border-l-0 border-gray-300 rounded-r-md"
                      [ngClass]="{'pointer-events-none':updateProductBundleForm.controls?.markup?.disabled, 'cursor-pointer': updateProductBundleForm.controls?.markup?.enabled }">
                      <span class="text-lg" *ngIf="markupType === 'FLAT'">
                        <i class="ti ti-plus"></i>
                      </span>
                      <span  class="text-lg" *ngIf="markupType === 'PERCENTAGE'">
                        <i class="ti ti-percentage"></i>
                      </span>
                      <span  class="text-lg" *ngIf="markupType === 'MULTIPLIER'">
                        <i class="ti ti-x"></i>
                      </span>
                      <em class="text-xl" class="ti ti-chevron-down text-base font-semibold ml-2"></em>
                      <mat-menu #dropdown="matMenu" class="markup-menu">
                        <div (click)="changeMarkupType('FLAT')">
                            <a mat-menu-item class="h-10">
                                <span class="ml-2 text-base space-x-2"> 
                                  <i class="ti ti-plus"></i> <span>{{'text.flat' | translate}}</span> 
                                </span>
                            </a>
                        </div>
                        <div (click)="changeMarkupType('PERCENTAGE')">
                            <a mat-menu-item class="h-10">
                                <span class="ml-2 text-base space-x-2">
                                  <i class="ti ti-percentage"></i><span>{{'text.percentage' | translate}}</span>
                                </span>
                            </a>
                        </div>
                        <div (click)="changeMarkupType('MULTIPLIER')">
                            <a mat-menu-item class="h-10">
                                <span class="ml-2 text-base space-x-2">
                                  <i class="ti ti-x"></i><span>{{'text.multiplier' | translate}}</span>
                                </span>
                            </a>
                        </div>
                      </mat-menu>
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </form>
      </div>
    </mat-expansion-panel>
  </a>
  <div class="zuper-dialog-header h-20 p-4">

    <div class="flex justify-between">
      <h5 class="my-3 text-lg font-semibold text-gray-700">
        <i class="ti ti-box-padding text-2xl"></i>
        <span class="ml-3">{{"bundle.title.label" | translate}}</span>
      </h5>
    </div>
    @if(showLineItemAction) {
      <div class="flex items-center space-x-2 ml-auto" >
        <ng-container>
          <a mat-stroked-button
              class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-red-700 bg-white hover:bg-gray-50 focus:outline-none" (click)="$event?.stopPropagation();removeSelectedLineItems();">
              <em class="text-xl" class="ti ti-trash text-xl"></em><span
                  class="ml-2 primary-font text-base leading-loose pt-0.5">{{"text.remove" |
                  translate}}</span>
           </a>
      </ng-container>
      </div>
    }
    @else {
      <div class="flex items-center space-x-2 ml-auto">
        <!-- Search Input -->
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
              fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clip-rule="evenodd"></path>
            </svg>
          </div>
          <input type="text" id="search" name="search" [(ngModel)]="searchText" (ngModelChange)="onModelChange()"
            (keyup.enter)="onSearchValueChange()"
            class="text-lg block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:border-indigo-500"
            placeholder="{{'text.search' | translate}}" autocomplete="off">
          <button mat-icon-button *ngIf="searchText?.length"
            class="mat-focus-indicator min-w-3 min-h-3 min-w 3 h-8 w-8 mat-icon-button mat-button-base absolute inset-y-0 right-0 mr-2"
            style="margin-top: 0.2rem;" (click)="searchText = ''; onModelChange();">
            <em class="ti ti-x close-mark cursor-pointer text-black text-2xl"></em>
          </button>
        </div>
        @if(this.selectedBundleDetails?.pricing_level === 'ROLLUP') {
          <!-- Add Menu Button -->
          <button [brnMenuTriggerFor]="itemsMenu" variant="outline" 
          class="w-[4.5] px-3 py-2 h-10 inline-flex items-center justify-center text-base text-color-normal border border-gray-300 rounded-md bg-white hover:bg-gray-100">
          <span><em class="ti ti-plus"></em> Add</span>
          </button>
          <!-- Add Menu Template -->
          <ng-template #itemsMenu>
            <hlm-menu>
              <hlm-menu-group>
                <button hlmMenuItem (click)="addLineItems($event, 'add_item')" class="cursor-pointer primary-font h-10">
                  <span class="text-base primary-font">{{'line_item.text' | translate}}</span>
                </button>
                <button *ngIf="options?.customLineItemPicker !== false" hlmMenuItem class="cursor-pointer primary-font h-10" (click)="addLineItems($event, 'add_custom_item')">
                  <span class="text-base primary-font">{{'job.details.pick_parts_menu.custom_line_item' | translate}}</span>
                </button>   
              </hlm-menu-group>
            </hlm-menu>
          </ng-template>
        }
      </div>
    }
  </div>
  <div class="overflow-container zuper-scrollbar product-items-content" *ngIf="mockAssociatedProducts?.length"
  [ngStyle]="{
   'height': isPrimaryDetailsExpanded ? (options.type !== 'EDIT' ? 'calc(100% - 24rem)' : 'calc(100% - 25rem)') : 'calc(100% - 9.5rem)',
   'overflow': 'hidden' }">
    <form autocomplete="off" [formGroup]="lineItemFormGroup" class="h-full">
      <div class="flex flex-col flex-auto overflow-auto mx-6 mb-4 hover-stripped zuper-scrollbar h-full"
      *ngIf="selectedBundleDetails?.associated_products?.length && options?.columns?.length && displayedColumns?.length" formArrayName="tableRows">
          <table mat-table #table [dataSource]="selectedBundleDetails.associated_products" class="line-item-products-table border-l border-r" aria-describedby="associated_products">
            <ng-container *ngFor="let column of options.columns;let i=index;" [matColumnDef]="column.type">
              <!-- Remove Line Item Column -->
              <ng-container  *ngIf="column.type === 'BULKACTION'">
                <th mat-header-cell *matHeaderCellDef style="width: 5%"
                  class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                </th>
                <td mat-cell *matCellDef="let element; let index = index" style="width: 5%" class="text-center">
                  <hlm-checkbox class="rounded border border-gray-400 h-5 w-5 mt-1" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectionMap[index]" (ngModelChange)="onCheckboxChange(index)"/>
                </td>
              </ng-container>
              <!-- Line Item Column -->
            <ng-container *ngIf="column.type === 'LINE_ITEM'">
                  <th mat-header-cell *matHeaderCellDef style="width:20%"
                      class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                      {{'text.item' | translate}} </th>
                  <td mat-cell *matCellDef="let element;let index=index" style="width:20%" class="text-base">
                      <label class="flex w-full px-2 cursor-default" for="{{'select_ele_' + index}}">
                        <div class="flex items-start">
                          <!-- Product Image -->
                          <div class="inline-flex overflow-hidden rounded-lg flex-shrink-0 my-3">
                            <img *ngIf="element?.product?.product_image"
                                 class="h-12 w-12 flex-shrink-0 border rounded-lg" loading="lazy"
                                 [src]="element.product?.product_image" alt="Product Image">
                            <img *ngIf="!element?.product?.product_image"
                                 class="h-12 w-12 flex-shrink-0 border rounded-lg" loading="lazy"
                                 src="assets/images/png/cubes.png" alt="Default Image">
                          </div>
                        
                          <!-- Product Name & Description -->
                          <div class="m-2 sm:ml-3 sm:flex-1 break-all w-3/5 my-3 primary-font">
                            <!-- Product Name -->
                            <div class="flex items-center">
                              <h3 class="font-bold text-base truncate" [title]="(element?.product?.prefix || element?.prefix ? (element?.product?.prefix || element?.prefix) + ' - ' : '') + 
                                          (element?.product?.product_id || element?.product_id ? (element?.product?.product_id || element?.product_id) + ' - ' : '') + 
                                          (element?.product?.product_name || element?.product_name || element?.name || '---')">
                                #
                                <ng-container *ngIf="element?.product?.prefix || element?.prefix">
                                  {{ element?.product?.prefix || element?.prefix }} -
                                </ng-container>
                                <ng-container *ngIf="element?.product?.product_id || element?.product_id">
                                  {{ element?.product?.product_id || element?.product_id }} -
                                </ng-container>
                                {{ element?.product?.product_name || element?.product_name || element?.name || '---' }}
                              </h3>
                            </div>
                            <!-- Description (Read-only or Editable) -->
                            <div class="flex items-center min-w-40 max-w-60 mt-1 space-x-2 group">
                              <div class="w-10/12 truncate primary-font h-6">
                                <div class="truncate" [innerHTML]="(element.product_description || element?.description || '---') | safeHtml: false"></div>
                              </div>
                              <div class="flex items-center justify-center">
                                <img class="action-icon inline-flex items-center cursor-pointer icon-size-6 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                    src="assets/icons/edit-icon.svg"
                                    title="{{'job.details.actions.description' | translate}}"
                                    (click)="editDescription(element, index)" 
                                    alt="Edit">
                              </div>
                            </div>
                          </div>
                        </div>
                      </label>
                  </td>
              </ng-container>
              <!-- Product Type Column -->
              <ng-container *ngIf="column.type === 'CATEGORY'">
                  <th mat-header-cell *matHeaderCellDef style="width:10%"
                      class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                      {{'category.text' | translate}} </th>
                  <td mat-cell *matCellDef="let element" style="width:10%" class="text-base">
                      <div class="text-base max-w-2/12 px-2 py-3">
                          {{element?.product_category?.category_name ?? element?.product?.product_category?.category_name ?? '---'}}
                      </div>
                  </td>
              </ng-container>
              <!-- Product Type Column -->
              <ng-container *ngIf="column.type === 'TYPE'">
                  <th mat-header-cell *matHeaderCellDef style="width:10%"
                      class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                      {{'text.type' | translate}} </th>
                  <td mat-cell *matCellDef="let element" style="width:10%" class="text-base">
                      <div class="w-full truncate capitalize primary-font px-2">
                          {{(element.product_type === 'PARTS' ? 'PART' : element.product_type) |
                          lowercase}}
                      </div>
                  </td>
              </ng-container>
              <!-- Location Column -->
              <ng-container *ngIf="column.type === 'LOCATION'">
                <th mat-header-cell *matHeaderCellDef
                    class="text-left min-w-60 max-w-60 text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                    {{'text.location' | translate}}<span class="mandatory-field"
                        *ngIf="column?.isRequired">*</span></th>
                <td mat-cell *matCellDef="let element;let index = index"
                    class="text-base min-w-60 max-w-60">
                    <div *ngIf="!column.isEditable" class="mx-2 w-full truncate primary-font">
                        {{element?.location_name ??
                        (element?.location_availability[0]?.location?.location_name ?? '')}}
                    </div>
                    <div class="flex items-center mx-2" [ngClass]="{'pt-5': lineItemFormGroup.get(['tableRows', index, 'location'])?.invalid}" *ngIf="column.isEditable">
                        <mat-form-field class="w-full" appearance="fill" *ngIf="element?.location_availability?.length > 0">
                          <mat-select (selectionChange)="onProductLocationChange($event, element, index)"                                        
                          [disableOptionCentering]="true" [formControl]="lineItemFormGroup.get(['tableRows', index, 'location'])"
                            [panelClass]="['zuper-scrollbar']" placeholder="{{'text.choose_location' | translate}}">
                            <mat-option [value]="''">
                                <span
                                    class="primary-font text-base">{{'no.location.text'|translate}}</span>
                            </mat-option>
                            <mat-option *ngFor="let locations of element?.location_availability"
                                [value]="locations?.location?.location_uid">
                                <span
                                    class="primary-font text-base">{{locations?.location?.location_name}} 
                                    <span *ngIf="locations?.quantity">
                                      {{'(' + locations?.quantity + ')'}}</span>
                                    </span>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="text-red-500 h-5 ml-2 p-1" *ngIf="lineItemFormGroup.get(['tableRows', index, 'location'])?.invalid">
                      <span class="text-base" *ngIf="lineItemFormGroup.get(['tableRows', index, 'location'])?.hasError('required')">{{'lineitem.picker.required.error' | translate}} </span>
                    </div>
                </td>
              </ng-container>
              <!-- Quantity Column -->
              <ng-container *ngIf="column.type === 'QUANTITY'">
                  <th mat-header-cell *matHeaderCellDef style="width:10%"
                      class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                      {{'text.quantity' | translate}}
                      @if(selectedBundleDetails?.pricing_level === 'ROLLUP'){
                        <span class="mandatory-field">*</span>
                      }
                  </th>
                  <td mat-cell *matCellDef="let element;let index = index" style="width:10%" class="text-base">
                      @if(selectedBundleDetails?.pricing_level === 'ROLLUP'){
                        <div class="min-w-30 max-w-40 mx-2 pt-6">
                          <input type="number" title="" placeholder="Eg: 20"
                            restrictNumberDecimal [required]="column.isRequired" [step]="stepValue"
                            [formControl]="lineItemFormGroup.get(['tableRows', index, 'quantity'])" [value]="element?.quantity ?? ''"
                            [ngClass]="{'border-red-500': lineItemFormGroup.get(['tableRows', index, 'quantity'])?.invalid, 'border-gray-300': !lineItemFormGroup.get(['tableRows', index, 'quantity'])?.invalid}"
                            class="h-11 w-full rounded-md border bg-white shadow-sm p-3 text-base primary-font selling-price"
                            (change)="onLineItemQuantityChange(index, element)">
                          <span class="text-red-500 text-base"
                            [ngClass]="{'invisible': !lineItemFormGroup.get(['tableRows', index, 'quantity'])?.errors?.required}">{{'lineitem.picker.required.error'
                            | translate}}</span>
                        </div>   
                      }@else{
                        <div class="w-full truncate capitalize primary-font px-2">
                          <span>{{selectedBundleDetails?.quantity}}</span>  
                          <span class="mx-2">
                              <i class="ti ti-x text-base text-gray-700 cursor-default"></i>
                          </span>
                            {{element?.quantity}}
                        </div>
                      }
                  </td>
              </ng-container>
              <!-- Purchase Price Column -->
              <ng-container *ngIf="column.type === 'PURCHASE_PRICE'">
                <th mat-header-cell *matHeaderCellDef style="width:10%"
                    class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                    {{'text.unit_purchase_price' | translate}} (in {{companyCurrency}})<span
                        class="mandatory-field" *ngIf="column.isRequired">*</span></th>
                <td mat-cell *matCellDef="let element;let index = index" style="width:10%"
                    class="text-base"  >
                    <div *ngIf="!column.isEditable" class="mx-2 w-full truncate primary-font">
                        {{element?.purchase_price ?? ''}}
                    </div>
                    <div *ngIf="column.isEditable" class="min-w-30 max-w-40 mx-2 pt-5">
                        <input type="number" name="{{'purchase_price_'+i}}" id="{{'purchase_price_'+i}}" title="" placeholder="Eg: 20"
                            restrictNumberDecimal
                            [required]="column.isRequired" [step]="stepValue" [formControl]="lineItemFormGroup.get(['tableRows', index, 'purchase_price'])"
                            [value]="element?.purchase_price ?? ''"
                            [ngClass]="{'border-red-500': lineItemFormGroup.get(['tableRows', index, 'purchase_price'])?.invalid, 'border-gray-300': !lineItemFormGroup.get(['tableRows', index, 'purchase_price'])?.invalid}"
                            class="h-11 w-full rounded-md border bg-white shadow-sm p-3 text-base primary-font border-gray-300">
                            <div class="text-red-500 h-5">
                              <span class="text-base" *ngIf="lineItemFormGroup.get(['tableRows', index, 'purchase_price'])?.hasError('required')">{{'lineitem.picker.required.error'
                                  | translate}}</span>
                              <div class="text-sm my-0.5 flex items-center pt-1 truncate" *ngIf="lineItemFormGroup.get(['tableRows', index, 'purchase_price'])?.hasError('min')">
                                  {{('text.purchase_price.invalid' | translate)}}
                              </div>
                          </div>
                    </div>
                </td>
              </ng-container>
              <!-- Serial no Column -->
              <ng-container *ngIf="column.type === 'SERIAL_NO'">
                <th mat-header-cell *matHeaderCellDef
                    class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                    {{'text.serial_no' | translate}}<span class="mandatory-field"
                        *ngIf="column.isRequired">*</span></th>
                <td mat-cell class="min-w-64" *matCellDef="let element;let index=index"
                    [ngClass]="{'pt-5': lineItemFormGroup.get(['tableRows', index, 'serialNumber'])?.hasError('mismatchCount')}" class="text-base">
                    <div *ngIf="!column.isEditable" class="mx-2 w-11/12 truncate primary-font">
                        {{element.serial_nos ?? ''}}
                    </div>
                    <div *ngIf="column.isEditable" class="mx-2 primary-font">
                        <ng-select class="text-base min-w-64"  appendTo="body"
                            id="{{'product_serial_no_' + index}}" [addTag]="column.allowAddValue ?? false"
                            [formControl]="lineItemFormGroup.get(['tableRows', index, 'serialNumber'])"
                            placeholder="Eg: AC0001" (blur)="onSerialNoBlur($event,index,element)" (change)="serialNumberChanged(index,element)" addTagText=""
                            [hideSelected]="true" [multiple]="column.multiple ?? false"
                            (open)="disableParentScroll()" 
                            (close)="enableParentScroll()">
                            <ng-option *ngFor="let serialNumber of getProductSerialNumbers(element); trackBy:trackByValue"
                                        [value]="serialNumber">
                              <div class="primary-font text-base">{{serialNumber}}</div>
                            </ng-option>
                        </ng-select>
                        <span class="text-red-500 text-base" *ngIf="lineItemFormGroup.get(['tableRows', index, 'serialNumber'])?.hasError('mismatchCount')">
                          *{{'lineitem.picker.serialCount_quantity.error' | translate}}</span>
                    </div>
                </td>
              </ng-container>
              <!-- Markup Column -->
              <ng-container *ngIf="column.type === 'MARKUP'">
                <th mat-header-cell *matHeaderCellDef style="width:15%"
                    class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                    {{'text.markup' | translate}}<span
                        class="mandatory-field" *ngIf="column.isRequired">*</span></th>
                <td mat-cell *matCellDef="let element;let index = index" style="width:15%"
                    class="text-base" >
                    <div *ngIf="!column.isEditable" class="mx-2 w-11/12 truncate primary-font">
                        {{element?.markup?.markup_value ?? ''}}
                    </div>
                    <div *ngIf="column.isEditable" class="min-w-40 max-w-40 mx-2">
                        <div class="flex justify-center items-center">
                            <input type="number" name="{{'markup_value_'+i}}" id="{{'markup_value_'+i}}" min="0" title="" placeholder="Eg: 10"
                                restrictNumberDecimal
                                [required]="column.isRequired" [step]="stepValue" [formControl]="lineItemFormGroup.get(['tableRows', index, 'markup_value'])"
                                [value]="element?.markup?.markup_value ?? ''"
                                (change)="markupValueChange($event)"
                                class="h-11 w-2/3 rounded-l-md border bg-white shadow-sm p-3 text-base primary-font border-gray-300">
                            <span [matMenuTriggerFor]="dropdown"
                                    class="w-1/3 h-11 inline-flex items-center px-2 text-sm m-0 text-gray-900 border border-l-0 border-gray-300 rounded-r-md"
                                    [ngClass]="{
                                        'pointer-events-none opacity-50 bg-gray-50':lineItemFormGroup.get(['tableRows', index, 'markup_value'])?.disabled,
                                        'cursor-pointer':lineItemFormGroup.get(['tableRows', index, 'markup_value'])?.enabled
                                        }">
                                <span class="text-lg" *ngIf="element?.markup?.markup_type === 'FLAT'">
                                <i class="ti ti-plus"></i>
                                </span>
                                <span  class="text-lg" *ngIf="element?.markup?.markup_type === 'PERCENTAGE'">
                                <i class="ti ti-percentage"></i>
                                </span>
                                <span  class="text-lg" *ngIf="element?.markup?.markup_type === 'MULTIPLIER'">
                                <i class="ti ti-x"></i>
                                </span>
                                <span  class="text-lg" *ngIf="!element?.markup && (getMarkupType(element) === 'FLAT')">
                                <i class="ti ti-plus"></i>
                                </span>
                                <span  class="text-lg" *ngIf="!element?.markup && (getMarkupType(element) === 'PERCENTAGE')">
                                <i class="ti ti-percentage"></i>
                                </span>
                                <span  class="text-lg" *ngIf="!element?.markup && (getMarkupType(element) === 'MULTIPLIER')">
                                <i class="ti ti-x"></i>
                                </span>
                                <em class="text-xl" class="ti ti-chevron-down text-base font-semibold ml-2"></em>
                                <mat-menu #dropdown="matMenu" class="markup-menu">
                                    <div (click)="changeMarkupType('FLAT', element)">
                                        <a mat-menu-item class="h-10">
                                            <span class="ml-2 text-base space-x-2"> 
                                                <i class="ti ti-plus"></i> <span>{{'text.flat' | translate}}</span> 
                                            </span>
                                        </a>
                                    </div>
                                    <div (click)="changeMarkupType('PERCENTAGE', element)">
                                        <a mat-menu-item class="h-10">
                                            <span class="ml-2 text-base space-x-2">
                                                <i class="ti ti-percentage"></i><span>{{'text.percentage' | translate}}</span>
                                            </span>
                                        </a>
                                    </div>
                                    <div (click)="changeMarkupType('MULTIPLIER', element)">
                                        <a mat-menu-item class="h-10">
                                            <span class="ml-2 text-base space-x-2">
                                                <i class="ti ti-x"></i><span>{{'text.multiplier' | translate}}</span>
                                            </span>
                                        </a>
                                    </div>
                                </mat-menu>
                            </span>
                        </div>
                    </div>
                </td>
              </ng-container>
              <!-- Product Price Column -->
              <ng-container *ngIf="column.type === 'PRICE'">
                <th mat-header-cell *matHeaderCellDef style="width:10%"
                    class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                    {{'text.unit_selling_price' | translate}} (in {{companyCurrency}})<span
                        class="mandatory-field" *ngIf="column.isRequired">*</span></th>
                <td mat-cell *matCellDef="let element;let index = index" style="width:10%"
                    class="text-base" >
                    <div *ngIf="!column.isEditable" class="mx-2 w-11/12 truncate primary-font">
                        {{element?.price ?? element?.unit_price ?? ''}}
                    </div>
                    <div *ngIf="column.isEditable" class="min-w-30 max-w-40 mx-2 mt-5" matTooltipPosition="above">
                        <input type="number" name="{{'price_'+i}}" id="{{'price_'+i}}" title="" placeholder="Eg: 20" restrictNumberDecimal
                            [required]="column.isRequired" [step]="stepValue" [formControl]="lineItemFormGroup.get(['tableRows', index, 'price'])"
                            [value]="element?.price ?? element?.unit_price ?? ''"
                            [ngClass]="{'border-red-500': lineItemFormGroup.get(['tableRows', index, 'price'])?.invalid, 'border-gray-300': !lineItemFormGroup.get(['tableRows', index, 'price'])?.invalid}"
                            class="h-11 w-full rounded-md border bg-white shadow-sm p-3 text-base primary-font selling-price">
                        <span class="text-red-500 text-base"
                            [ngClass]="{'invisible': !lineItemFormGroup.get(['tableRows', index, 'price'])?.errors?.required}">{{'lineitem.picker.required.error'
                            | translate}}</span>
                    </div>
                </td>
              </ng-container>
              <!-- Discount Column -->
              <ng-container *ngIf="column.type === 'DISCOUNT'">
                <th mat-header-cell *matHeaderCellDef class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                  {{ 'text.discount' | translate }}
                </th>
                <td class="text-base w-fit px-2 py-3" mat-cell *matCellDef="let element; let index = index">
                  <div class="min-w-40 max-w-50 mx-2 mt-2">
                    <!-- Discount Input Field -->
                    <mat-form-field class="w-full" appearance="fill">
                      <input type="number" matInput step="1" restrictNumberDecimal name="{{'discount_' + index}}" id="{{'discount_' + index}}"
                        placeholder="{{'placeholder.discount' | translate}}" min="0" [formControl]="lineItemFormGroup.get(['tableRows', index, 'discount'])"
                        class="block w-full rounded-md border border-gray-300 focus:border-indigo-500 px-3 py-3 leading-none text-base">
                      <span matPrefix>
                        <mat-select [formControl]="lineItemFormGroup.get(['tableRows', index, 'discount_type'])" (selectionChange)="onProductDiscountTypeChange($event, index, element)" matPrefix>
                          <mat-option [value]="option.value" *ngFor="let option of discountType">{{option.key}}</mat-option>
                        </mat-select>
                      </span>
                    </mat-form-field>
                  </div>
                  <!-- Error Message for Invalid Discount -->
                  <span class="text-red-500 text-base" 
                    *ngIf="(lineItemFormGroup.get(['tableRows', index, 'discount'])?.touched && lineItemFormGroup.get(['tableRows', index, 'discount'])?.value < 0)">
                    {{ 'text.minimum.value' | translate }} (0)
                  </span>
                </td>
              </ng-container>

              <!-- Tax Preference column -->
              <ng-container *ngIf="column.type === 'TAX_PREFERENCE'">
                <th mat-header-cell *matHeaderCellDef class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                  {{ 'tax.preference.label' | translate }}
                </th>
                <td class="text-base w-fit px-2 py-3" mat-cell *matCellDef="let element; let index = index">
                  <div class="min-w-40 max-w-50 mx-2 mt-2">
                    <mat-form-field appearance="fill" class="w-full mt-1 mb-1">
                      <mat-select [formControl]="lineItemFormGroup.get(['tableRows', index, 'tax_preference'])">
                          <mat-option [value]="true"> {{ "text.non_taxable" | translate}} </mat-option>
                          <mat-option [value]="false"> {{ "taxable.text" | translate}} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </td>
              </ng-container>

              <!-- Tax Code column -->
              <ng-container *ngIf="column.type === 'TAX_CODE'">
                <th mat-header-cell *matHeaderCellDef class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2">
                  {{ 'text.tax_code' | translate }}
                </th>
                <td class="text-base w-fit px-2 py-3" mat-cell *matCellDef="let element; let index = index">
                  <div class="min-w-40 max-w-50 mx-2 mt-2">
                    <app-tax-code (codeSelected)="changeLineItemTaxCode($event, index)" [value]="element?.tax?.tax_code"></app-tax-code>
                  </div>
                </td>
              </ng-container>

              <!-- Action column -->
              <ng-container *ngIf="column.type === 'ACTION' && !showLineItemAction">
                <th mat-header-cell *matHeaderCellDef class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase primary-font px-2 sticky right-0 z-[101]">
                  {{ 'text.action' | translate }}
                </th>
                <td class="text-base w-fit px-2 py-3 sticky right-0 z-10 bg-white" mat-cell *matCellDef="let element; let index = index">
                  <div class="flex justify-center items-center">
                    <span class="action-btn rounded cursor-pointer" matTooltip="{{'text.remove' | translate}}" matTooltipPosition="above" (click)="removeLineItem(index)">
                      <i class="ti ti-trash text-lg text-red-600 font-medium"></i>
                    </span>
                  </div>
                </td>
              </ng-container>

            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true;" class="bg-gray-50"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
      </div>
    </form>
    <div class="h-80 mb-4 flex flex-col items-center justify-center" *ngIf="!selectedBundleDetails?.associated_products?.length && searchText?.length">
        <div class="flex flex-col items-center justify-center">
            <div class="flex justify-center px-2 text-center primary-font break-words">
              <span class="">{{'bundle.picker.line_item_not_found.text' | translate}} '{{searchText}}'</span>
            </div>
        </div>
    </div>
    <div class="h-80 mb-4 flex flex-col items-center justify-center" *ngIf="!selectedBundleDetails?.associated_products?.length && searchText?.length === 0">
        <div class="flex flex-col items-center justify-center">
            <h4 class="font-medium mt-4 text-secondary">{{'lineitem.picker.line_item.placholder' |
                translate}}
            </h4>
        </div>
    </div>
  </div>
  <div class="flex text-right items-center border-gray-300 border-t zuper-dialog-footer" *ngIf="options?.modal?.footer?.isEnabled">
    <button type="button" mat-stroked-button mat-dialog-close
        class="btn-small ml-auto mr-4 primary-font x-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
        {{'cancel.text' | translate}}</button>
        <!-- [disabled]="!selectedProducts.length" -->
    <button (click)="validateSelectedItemsControls($event)" 
        class="flex btn-small primary-font bg-primary px-6 items-center py-2 border b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
        <mat-spinner [diameter]="18" class="mr-2" *ngIf="updatingBundle"></mat-spinner>
        {{(options?.modal.footer?.buttonDisplayKey || options?.modal.footer?.buttonDisplayName || 'add.text')
        | translate}}
    </button>
  </div>
</div>
<ng-container *ngIf="!masterProducts?.length && options?.type !== 'EDIT'">
  <div class="h-full mb-4 flex flex-col items-center justify-center">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_assets_found.svg" alt="No Line Items Found">
        <h4 class="font-medium mt-4 text-secondary">{{'bundle.picker.no_data.message' |  translate}}
        </h4>
    </div>
  </div>
</ng-container>
